var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EF4444;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.4,17l3.6-3.6l3.6,3.6l1.4-1.4L13.4,12L17,8.4L15.6,7L12,10.6L8.4,7L7,8.4l3.6,3.6L7,15.6L8.4,17z M12,22 c-1.4,0-2.7-0.3-3.9-0.8S5.8,20,4.9,19.1c-0.9-0.9-1.6-2-2.1-3.2S2,13.4,2,12s0.3-2.7,0.8-3.9S4,5.8,4.9,4.9s2-1.6,3.2-2.1 S10.6,2,12,2s2.7,0.3,3.9,0.8s2.3,1.2,3.2,2.1c0.9,0.9,1.6,2,2.1,3.2S22,10.6,22,12s-0.3,2.7-0.8,3.9s-1.2,2.3-2.1,3.2 c-0.9,0.9-2,1.6-3.2,2.1S13.4,22,12,22z M12,20c2.2,0,4.1-0.8,5.7-2.3c1.6-1.5,2.3-3.4,2.3-5.7c0-2.2-0.8-4.1-2.3-5.7 C16.1,4.8,14.2,4,12,4C9.8,4,7.9,4.8,6.3,6.3S4,9.8,4,12c0,2.2,0.8,4.1,2.3,5.7C7.9,19.2,9.8,20,12,20z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCloseIcon);
export default __webpack_public_path__ + "static/media/cancel-close-icon.120feadb54ff1284f8cfebba1affeb89.svg";
export { ForwardRef as ReactComponent };